<template>
  <div
    ref="locationsContainer"
    class="locations-container"
  >
    <div
      v-if="!isLoaded"
      class="locations__loader"
    >
      <div class="locations__loader__content">
        <div class="locations__loader__spinner" />
        <p>Loading locations...</p>
      </div>
    </div>
    <template v-else>
      <div class="locations">
        <div class="locations__content">
          <div class="locations__header">
            <h1 class="locations__title">
              Where Can You Find Us?
            </h1>
            <p class="locations__description">
              With 6 Locations Across Michigan, You May Have Seen Our Vehicles Making Deliveries.
              With our warehouse based in Grand Rapids, we are proud to service businesses all
              around the State!
            </p>
          </div>

          <div
            class="locations__active-branch"
            @mouseenter="pauseRotation"
            @mouseleave="resumeRotation"
          >
            <div class="locations__active-branch__content">
              <h4>{{ activeBranch?.address.city }}</h4>
              <ul class="locations__active-branch__info list-custom">
                <li
                  v-if="activeBranch?.phone"
                  class="locations__info locations__info--phone"
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.82032 8.70125C1.11407 6.66219 0.303131 4.5575 0.593756 2.93563V2.89813V2.86063C1.46563 0.573126 3.96407 0.516876 4.34376 1.745L5.09376 3.93875C5.15388 4.11958 5.16249 4.31358 5.11861 4.49902C5.07474 4.68447 4.98011 4.85404 4.84532 4.98875L4.09532 5.73875C4.78655 7.25767 6.00112 8.47723 7.51719 9.17469L8.15001 8.54188C8.27518 8.41618 8.43079 8.32506 8.60167 8.27742C8.77254 8.22977 8.95285 8.22721 9.12501 8.27L11.6563 8.89813C12.8563 9.24031 12.9406 11.7106 10.4984 12.7278C7.95782 13.4356 4.57813 10.7966 2.82032 8.70125Z"
                      fill="#FEC327"
                    />
                  </svg>
                  <a :href="`tel:${activeBranch.phone}`">{{ activeBranch.phone }}</a>
                </li>
                <li
                  v-if="activeBranch?.email"
                  class="locations__info locations__info--email"
                >
                  <svg
                    width="15"
                    height="12"
                    viewBox="0 0 15 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.8266 0.744995H3.17344C2.45687 0.747466 1.77036 1.03322 1.26366 1.53991C0.756972 2.0466 0.471221 2.73312 0.46875 3.44968V9.29031C0.471221 10.0069 0.756972 10.6934 1.26366 11.2001C1.77036 11.7068 2.45687 11.9925 3.17344 11.995H11.8266C12.5431 11.9925 13.2296 11.7068 13.7363 11.2001C14.243 10.6934 14.5288 10.0069 14.5312 9.29031V3.44968C14.5288 2.73312 14.243 2.0466 13.7363 1.53991C13.2296 1.03322 12.5431 0.747466 11.8266 0.744995ZM4.1625 9.12624L2.8125 10.495C2.6186 10.4248 2.44251 10.3129 2.2967 10.1671C2.15088 10.0212 2.03892 9.84515 1.96875 9.65125L3.3375 8.2825C3.44752 8.17247 3.59675 8.11066 3.75234 8.11066C3.90794 8.11066 4.05716 8.17247 4.16719 8.2825C4.27721 8.39252 4.33902 8.54174 4.33902 8.69734C4.33902 8.85294 4.27721 9.00216 4.16719 9.11218L4.1625 9.12624ZM12.1875 10.495L10.8188 9.12624C10.7087 9.01622 10.6469 8.867 10.6469 8.7114C10.6469 8.55581 10.7087 8.40658 10.8188 8.29656C10.9288 8.18653 11.078 8.12472 11.2336 8.12472C11.3892 8.12472 11.5384 8.18653 11.6484 8.29656L13.0312 9.65125C12.9611 9.84515 12.8491 10.0212 12.7033 10.1671C12.5575 10.3129 12.3814 10.4248 12.1875 10.495ZM13.125 3.79656L9.81563 6.96531C9.16559 7.61222 8.28583 7.97539 7.36875 7.97539C6.45167 7.97539 5.57191 7.61222 4.92188 6.96531L1.875 3.86687V3.5575C1.87627 3.33958 1.92817 3.12494 2.0266 2.93052C2.12504 2.73609 2.26731 2.5672 2.44219 2.43718L5.925 5.96687C6.31155 6.35187 6.8349 6.56803 7.38047 6.56803C7.92604 6.56803 8.44939 6.35187 8.83594 5.96687L12.5344 2.41843C12.7161 2.54783 12.8645 2.71862 12.9672 2.91668C13.0699 3.11474 13.124 3.33439 13.125 3.5575V3.79656Z"
                      fill="#FEC327"
                    />
                  </svg>
                  <a :href="`mailto:${activeBranch.email}`">{{ activeBranch.email }}</a>
                </li>
                <li
                  v-if="activeBranch?.address?.line1"
                  class="locations__info locations__info--address"
                >
                  <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_8098_1796)">
                      <path
                        d="M7.36875 0.869995C5.91172 0.869995 4.51436 1.4488 3.48408 2.47908C2.4538 3.50936 1.875 4.90671 1.875 6.36375C1.875 10.1887 6.92344 14.9325 7.36875 14.9325C7.81406 14.9325 12.8625 10.1887 12.8625 6.36375C12.8625 4.90671 12.2837 3.50936 11.2534 2.47908C10.2231 1.4488 8.82578 0.869995 7.36875 0.869995ZM7.36875 8.70749C6.9052 8.70749 6.45206 8.57004 6.06663 8.3125C5.6812 8.05497 5.3808 7.68892 5.20341 7.26066C5.02601 6.8324 4.9796 6.36115 5.07003 5.9065C5.16047 5.45186 5.38369 5.03424 5.71147 4.70646C6.03925 4.37868 6.45686 4.15546 6.91151 4.06503C7.36615 3.9746 7.8374 4.02101 8.26566 4.1984C8.69393 4.3758 9.05997 4.6762 9.31751 5.06163C9.57504 5.44706 9.7125 5.9002 9.7125 6.36375C9.7125 6.98535 9.46557 7.58149 9.02603 8.02103C8.58649 8.46056 7.99035 8.70749 7.36875 8.70749Z"
                        fill="#FEC327"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_8098_1796">
                        <rect
                          width="15"
                          height="15"
                          fill="white"
                          transform="translate(0 0.401245)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <div>
                    {{ activeBranch.address.line1 }}<br>
                    {{ activeBranch.address.city }}, {{ activeBranch.address.state }}
                    {{ activeBranch.address.zip }}
                  </div>
                </li>
                <li>
                  <a
                    class="btn-custom primary hide"
                    href="/locations"
                  >
                    All Locations
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="locations__map">
          <img
            src="https://us.evocdn.io/dealer/1550/content/media/My_Theme/map.svg"
            alt="Map"
            class="locations__map__background"
          >
          <div class="locations__pins">
            <div
              v-for="branch in branches"
              :key="branch.code"
              class="locations__pin"
              :class="{ 'locations__pin--selected': activeBranch?.id === branch.id }"
              :style="getPinPosition(branch)"
              @click="setActiveBranch(branch)"
              @mouseenter="setActiveBranch(branch)"
            >
              <svg
                class="locations__pin-marker"
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M14.2463 0.90625C11.4293 0.90625 8.72776 2.02527 6.73589 4.01714C4.74402 6.00901 3.625 8.71057 3.625 11.5275C3.625 18.9225 13.3853 28.0938 14.2463 28.0938C15.1072 28.0938 24.8675 18.9225 24.8675 11.5275C24.8675 8.71057 23.7485 6.00901 21.7566 4.01714C19.7647 2.02527 17.0632 0.90625 14.2463 0.90625ZM14.2463 16.0587C13.3501 16.0587 12.474 15.793 11.7288 15.2951C10.9837 14.7972 10.4029 14.0895 10.0599 13.2615C9.71696 12.4336 9.62723 11.5225 9.80207 10.6435C9.97691 9.76452 10.4085 8.95713 11.0422 8.32342C11.6759 7.68972 12.4833 7.25816 13.3622 7.08332C14.2412 6.90848 15.1523 6.99821 15.9803 7.34117C16.8083 7.68413 17.5159 8.26491 18.0138 9.01007C18.5117 9.75523 18.7775 10.6313 18.7775 11.5275C18.7775 12.7293 18.3001 13.8818 17.4503 14.7316C16.6006 15.5814 15.448 16.0587 14.2463 16.0587Z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { animate } from 'animejs';

export default {
  name: 'LocationsList',
  data() {
    return {
      branches: [],
      activeBranch: null,
      rotationInterval: null,
      isRotationPaused: false,
      rotationIntervalDuration: 15000, // 15 seconds in milliseconds
      isLoaded: false,
      hasAnimated: false,
      // Fixed positions for each branch based on the SVG map
      branchPositions: {
        MAIN: { x: 700, y: 260 }, // Grand Rapids
        Kalamazoo: { x: 700, y: 320 },
        Muskegon: { x: 655, y: 230 },
        Petoskey: { x: 710, y: 20 },
        Traverse: { x: 675, y: 80 },
        Warren: { x: 890, y: 270 },
      },
    };
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  beforeUnmount() {
    this.stopRotation();
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    setupIntersectionObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isLoaded) {
            this.fetchBranchesList();
          } else if (entry.isIntersecting && this.isLoaded && !this.hasAnimated) {
            this.$nextTick(() => {
              this.animatePins();
              this.hasAnimated = true;
            });
          }
        });
      }, {
        rootMargin: '200px 0px',
        threshold: 0.1,
      });

      if (this.$refs.locationsContainer) {
        this.observer.observe(this.$refs.locationsContainer);
      }
    },
    fetchBranchesList() {
      $.ajax({
        type: 'get',
        url: '/branches-list',
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        success: (response) => {
          this.branches = response;
          if (this.branches.length > 0) {
            const [firstBranch] = this.branches;
            this.activeBranch = firstBranch;
            this.startRotation();
            this.isLoaded = true;

            // Check if we should animate immediately
            if (this.$refs.locationsContainer) {
              const rect = this.$refs.locationsContainer.getBoundingClientRect();
              const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
              if (isVisible && !this.hasAnimated) {
                this.$nextTick(() => {
                  this.animatePins();
                  this.hasAnimated = true;
                });
              }
            }
          }
        },
        error: (error) => {
          console.error('Error fetching branches list:', error);
        },
      });
    },
    animatePins() {
      const pins = document.querySelectorAll('.locations__pin');

      pins.forEach((pin, index) => {
        // Set initial position (above the final position)
        const position = this.getPinPosition(this.branches[index]);
        pin.style.position = 'absolute';
        pin.style.left = position.left;
        pin.style.top = position.top;
        pin.style.transform = 'translateY(-100px)';
        pin.style.opacity = '0';
        pin.style.visibility = 'visible';

        // Animate to final position
        animate(pin, {
          translateY: 0,
          opacity: 1,
          duration: 800,
          delay: index * 300,
          easing: 'easeOutBounce',
        });
      });
    },
    getPinPosition(branch) {
      const position = this.branchPositions[branch.code] || { x: 0, y: 0 };
      return {
        left: `${position.x}px`,
        top: `${position.y}px`,
      };
    },
    setActiveBranch(branch) {
      this.activeBranch = branch;
      this.stopRotation();
      this.startRotation();
    },
    startRotation() {
      this.stopRotation();
      this.rotationInterval = setInterval(() => {
        if (!this.isRotationPaused) {
          const currentIndex = this.branches.findIndex((b) => b.id === this.activeBranch.id);
          const nextIndex = (currentIndex + 1) % this.branches.length;
          this.activeBranch = this.branches[nextIndex];
        }
      }, this.rotationIntervalDuration);
    },
    stopRotation() {
      if (this.rotationInterval) {
        clearInterval(this.rotationInterval);
        this.rotationInterval = null;
      }
    },
    pauseRotation() {
      this.isRotationPaused = true;
    },
    resumeRotation() {
      this.isRotationPaused = false;
    },
  },
};
</script>
